import { capitalize } from 'lodash';

import { getImpersonationExpiresAt } from '../../../utils/helpers/storage';

import { BannerContainer } from './ImpersonationBanner.styles';
import { useCountdown } from './useCountdown';

interface ImpersonationBannerProps {
  organizerName: string;
  accountName: string;
}

export const ImpersonationBanner: React.FC<ImpersonationBannerProps> = ({ organizerName, accountName }) => {
  const [minutes, seconds] = useCountdown(getImpersonationExpiresAt());

  return (
    <BannerContainer>
      <span>
        You are currently impersonating user <b>{organizerName}</b> in account <b>{accountName}</b> on{' '}
        <b>RideIQ - {capitalize(window.env?.RIDEIQ_ENVIRONMENT)}</b>
      </span>
      <span>
        <b>
          Your session will expire in {minutes}:{seconds}
        </b>
      </span>
    </BannerContainer>
  );
};
